export const sharedStartupGateDe = {
  "Startup delayed title": "Der Start dauert länger als erwartet.",
  "Startup delayed hint": "Wir prüfen weiter. Du kannst die Prüfung erneut starten.",
  "Retry startup check": "erneut prüfen",
  "Restoring the connection…": "Wir stellen die Verbindung her…",
  "Database is being checked…": "Ein letzter Check vor dem Start…",
  "Database is being updated…": "Wir bringen alles auf den neuesten Stand…",
  "Application is loading…": "Wir machen alles startklar…",
  "Application update in progress": "Die Anwendung wird vorbereitet…",
  "UI deploy reload failed title": "Die Anwendung konnte nicht geladen werden.",
  "UI deploy reload failed hint": "Bitte lade die Seite erneut.",
  "Reload": "neu laden",
  "The application is being updated": "Wir bringen alles auf den neuesten Stand…",
  "The application is currently unavailable": "Die Anwendung ist derzeit nicht erreichbar.",
  "Please wait a moment. The application will continue automatically.": "Danach geht es automatisch weiter.",
  "Sign-in and all functions are temporarily unavailable. Please try again in a few minutes.": "Anmeldung und Funktionen sind gerade nicht verfügbar. Bitte versuche es später erneut.",
  "Startup loading hint": "Noch einen Moment, dann kann’s losgehen.",
  "Startup check hint": "Wir prüfen, ob alles bereit ist.",
  "Startup migration hint": "Danach geht es automatisch weiter.",
  "Startup deploy hint": "Danach geht es automatisch weiter.",
  "Startup connection hint": "Danach geht es automatisch weiter.",
  "Startup unavailable hint": "Wir prüfen automatisch, wann die Anwendung wieder erreichbar ist.",
  "Application starting": "Wir stellen die Verbindung her…",
} as const;

export const sharedStartupGateEn = {
  "Startup delayed title": "Starting is taking longer than expected.",
  "Startup delayed hint": "We’re still checking. You can restart the check.",
  "Retry startup check": "Check again",
  "Restoring the connection…": "We’re connecting…",
  "Database is being checked…": "One last check before we start…",
  "Database is being updated…": "We’re bringing everything up to date…",
  "Application is loading…": "We’re getting everything ready…",
  "Application update in progress": "The application is getting ready…",
  "UI deploy reload failed title": "The application could not be loaded.",
  "UI deploy reload failed hint": "Please reload the page.",
  "Reload": "Reload",
  "The application is being updated": "We’re bringing everything up to date…",
  "The application is currently unavailable": "The application is currently unreachable.",
  "Please wait a moment. The application will continue automatically.": "We’ll continue automatically afterwards.",
  "Sign-in and all functions are temporarily unavailable. Please try again in a few minutes.": "Sign-in and features are currently unavailable. Please try again later.",
  "Startup loading hint": "Just a moment, then we’re ready to go.",
  "Startup check hint": "We’re checking that everything is ready.",
  "Startup migration hint": "We’ll continue automatically afterwards.",
  "Startup deploy hint": "We’ll continue automatically afterwards.",
  "Startup connection hint": "We’ll continue automatically afterwards.",
  "Startup unavailable hint": "We’ll automatically check when the application is available again.",
  "Application starting": "We’re connecting…",
} as const;

export const sharedStartupGateRu = {
  "Startup delayed title": "Запуск занимает больше времени, чем ожидалось.",
  "Startup delayed hint": "Проверка продолжается. Вы можете запустить её заново.",
  "Retry startup check": "Проверить снова",
  "Restoring the connection…": "Устанавливаем соединение…",
  "Database is being checked…": "Последняя проверка перед запуском…",
  "Database is being updated…": "Обновляем всё до актуальной версии…",
  "Application is loading…": "Готовим всё к работе…",
  "Application update in progress": "Приложение готовится к работе…",
  "UI deploy reload failed title": "Не удалось загрузить приложение.",
  "UI deploy reload failed hint": "Перезагрузите страницу.",
  "Reload": "Перезагрузить",
  "The application is being updated": "Обновляем всё до актуальной версии…",
  "The application is currently unavailable": "Приложение сейчас недоступно.",
  "Please wait a moment. The application will continue automatically.": "После этого работа продолжится автоматически.",
  "Sign-in and all functions are temporarily unavailable. Please try again in a few minutes.": "Вход и функции сейчас недоступны. Повторите попытку позже.",
  "Startup loading hint": "Ещё немного — и можно начинать.",
  "Startup check hint": "Проверяем, всё ли готово.",
  "Startup migration hint": "После этого работа продолжится автоматически.",
  "Startup deploy hint": "После загрузки работа продолжится автоматически.",
  "Startup connection hint": "После этого работа продолжится автоматически.",
  "Startup unavailable hint": "Мы автоматически проверяем, когда приложение снова станет доступно.",
  "Application starting": "Устанавливаем соединение…",
} as const;

export const sharedStartupGateUk = {
  "Startup delayed title": "Запуск триває довше, ніж очікувалося.",
  "Startup delayed hint": "Перевірка триває. Ти можеш запустити її знову.",
  "Retry startup check": "Перевірити знову",
  "Restoring the connection…": "Встановлюємо з’єднання…",
  "Database is being checked…": "Остання перевірка перед запуском…",
  "Database is being updated…": "Оновлюємо все до актуальної версії…",
  "Application is loading…": "Готуємо все до роботи…",
  "Application update in progress": "Застосунок готується до роботи…",
  "UI deploy reload failed title": "Не вдалося завантажити застосунок.",
  "UI deploy reload failed hint": "Перезавантаж сторінку.",
  "Reload": "Перезавантажити",
  "The application is being updated": "Оновлюємо все до актуальної версії…",
  "The application is currently unavailable": "Застосунок зараз недоступний.",
  "Please wait a moment. The application will continue automatically.": "Після цього робота продовжиться автоматично.",
  "Sign-in and all functions are temporarily unavailable. Please try again in a few minutes.": "Вхід і функції зараз недоступні. Спробуй ще раз пізніше.",
  "Startup loading hint": "Ще трохи — і можна починати.",
  "Startup check hint": "Перевіряємо, чи все готово.",
  "Startup migration hint": "Після цього робота продовжиться автоматично.",
  "Startup deploy hint": "Після завантаження робота продовжиться автоматично.",
  "Startup connection hint": "Після цього робота продовжиться автоматично.",
  "Startup unavailable hint": "Ми автоматично перевіряємо, коли застосунок знову стане доступним.",
  "Application starting": "Встановлюємо з’єднання…",
} as const;

export const sharedStartupGateIt = {
  "Startup delayed title": "L’avvio sta richiedendo più tempo del previsto.",
  "Startup delayed hint": "Il controllo continua. Puoi riavviarlo.",
  "Retry startup check": "Controlla di nuovo",
  "Restoring the connection…": "Stiamo stabilendo la connessione…",
  "Database is being checked…": "Un ultimo controllo prima di iniziare…",
  "Database is being updated…": "Stiamo aggiornando tutto…",
  "Application is loading…": "Stiamo preparando tutto…",
  "Application update in progress": "L’applicazione si sta preparando…",
  "UI deploy reload failed title": "Impossibile caricare l’applicazione.",
  "UI deploy reload failed hint": "Ricarica la pagina.",
  "Reload": "Ricarica",
  "The application is being updated": "Stiamo aggiornando tutto…",
  "The application is currently unavailable": "L’applicazione non è attualmente raggiungibile.",
  "Please wait a moment. The application will continue automatically.": "Poi si prosegue automaticamente.",
  "Sign-in and all functions are temporarily unavailable. Please try again in a few minutes.": "L’accesso e le funzioni non sono disponibili al momento. Riprova più tardi.",
  "Startup loading hint": "Ancora un momento e si parte.",
  "Startup check hint": "Controlliamo che tutto sia pronto.",
  "Startup migration hint": "Poi si prosegue automaticamente.",
  "Startup deploy hint": "Si prosegue automaticamente al termine del caricamento.",
  "Startup connection hint": "Poi si prosegue automaticamente.",
  "Startup unavailable hint": "Controlliamo automaticamente quando l’applicazione torna disponibile.",
  "Application starting": "Stiamo stabilendo la connessione…",
} as const;

export const sharedStartupGateTranslations = {
  de: sharedStartupGateDe,
  en: sharedStartupGateEn,
  ru: sharedStartupGateRu,
  uk: sharedStartupGateUk,
  it: sharedStartupGateIt,
} as const;

export type SharedStartupGateLang = keyof typeof sharedStartupGateTranslations;
export type SharedStartupGateKey = keyof typeof sharedStartupGateDe;
